import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist'
import { milestonesReducer } from './reducers/milestonesReducer';
import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import { uiReducer } from './reducers/uiReducer';

const composeEnhancers = (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const milestonesPersistConfig = {
  key: 'milestones',
  storage,
}

const rootReducers = combineReducers({
  milestones: persistReducer(milestonesPersistConfig, milestonesReducer),
  ui: uiReducer,
});

export const store = createStore(
  rootReducers,
  composeEnhancers(applyMiddleware(thunk)),
);

export const persistor = persistStore(store as any)
